var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatures(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 261,
    height: 66,
    viewBox: "0 0 261 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_41",
    x: 196,
    y: 0,
    width: 65,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#222"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_40",
    x: 147,
    y: 0,
    width: 65,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#222"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_39",
    x: 98,
    y: 0,
    width: 65,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#222"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_38",
    x: 49,
    y: 0,
    width: 65,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#222"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_37",
    x: 0,
    y: 0,
    width: 65,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#222"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4503",
    "data-name": "Group 4503",
    transform: "translate(-411 -247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4502",
    "data-name": "Group 4502"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 411, 247)",
    filter: "url(#Ellipse_41)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41-2",
    "data-name": "Ellipse 41",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(196)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(627 285)",
    fill: "#ff643a",
    fontSize: 22,
    fontFamily: "Raleway-Bold, Raleway",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+3"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4501",
    "data-name": "Group 4501",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 412, 247)",
    filter: "url(#Ellipse_40)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40-2",
    "data-name": "Ellipse 40",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(147)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3934",
    "data-name": "Group 3934",
    transform: "translate(577 265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart-histogram",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37598",
    "data-name": "Path 37598",
    d: "M23.05,22.048H5.011A3.007,3.007,0,0,1,2,19.042V1A1,1,0,1,0,0,1V19.042a5.017,5.017,0,0,0,5.011,5.011H23.05a1,1,0,1,0,0-2Z",
    transform: "translate(0 0)",
    fill: "#ff643a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37599",
    "data-name": "Path 37599",
    d: "M6.075,20.671A1.075,1.075,0,0,0,7.149,19.6V12.075a1.075,1.075,0,0,0-2.149,0V19.6A1.075,1.075,0,0,0,6.075,20.671Z",
    transform: "translate(-0.022 -0.454)",
    fill: "#ff643a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37600",
    "data-name": "Path 37600",
    d: "M10,10.075v9.671a1.075,1.075,0,1,0,2.149,0V10.075a1.075,1.075,0,1,0-2.149,0Z",
    transform: "translate(-0.044 -0.532)",
    fill: "#ff643a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37601",
    "data-name": "Path 37601",
    d: "M15,13.075v6.447a1.075,1.075,0,0,0,2.149,0V13.075a1.075,1.075,0,0,0-2.149,0Z",
    transform: "translate(-0.066 -0.408)",
    fill: "#ff643a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37602",
    "data-name": "Path 37602",
    d: "M20,9.075V19.82a1.075,1.075,0,0,0,2.149,0V9.075a1.075,1.075,0,1,0-2.149,0Z",
    transform: "translate(-0.246 -0.562)",
    fill: "#ff643a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37603",
    "data-name": "Path 37603",
    d: "M6.075,9.671a1.074,1.074,0,0,0,.76-.315L10.688,5.5a1.1,1.1,0,0,1,1.519,0l2.334,2.334a3.224,3.224,0,0,0,4.558,0l6-6a1.075,1.075,0,1,0-1.52-1.52l-6,6a1.075,1.075,0,0,1-1.519,0L13.727,3.983a3.224,3.224,0,0,0-4.558,0L5.315,7.837a1.075,1.075,0,0,0,.76,1.834Z",
    transform: "translate(-1.364 0)",
    fill: "#ff643a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4500",
    "data-name": "Group 4500",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 413, 247)",
    filter: "url(#Ellipse_39)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39-2",
    "data-name": "Ellipse 39",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(98)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3932",
    "data-name": "Group 3932",
    transform: "translate(528 264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "magic-wand",
    d: "M18.846,9.492A3.193,3.193,0,0,0,17.9,7.226a3.287,3.287,0,0,0-4.539,0L.939,19.655A3.209,3.209,0,0,0,5.473,24.19L17.9,11.761a3.191,3.191,0,0,0,.942-2.269ZM3.992,22.712a1.138,1.138,0,0,1-1.571,0,1.112,1.112,0,0,1,0-1.571L10.557,13l1.576,1.576ZM16.425,10.279,13.61,13.1l-1.571-1.576L14.855,8.7a1.113,1.113,0,1,1,1.571,1.571ZM5.089,2.99l1.623-.463L7.175.9a1.247,1.247,0,0,1,2.4,0l.463,1.623,1.623.463a1.247,1.247,0,0,1,0,2.4l-1.623.463L9.573,7.474a1.247,1.247,0,0,1-2.4,0L6.712,5.851,5.089,5.388a1.247,1.247,0,0,1,0-2.4ZM24.225,17.954l-1.623.463-.463,1.623a1.247,1.247,0,0,1-2.4,0l-.463-1.623-1.623-.463a1.247,1.247,0,0,1,0-2.4l1.623-.463.463-1.623a1.247,1.247,0,0,1,2.4,0l.463,1.623,1.623.463a1.247,1.247,0,0,1,0,2.4ZM18.589,2.618l1.42-.405L20.417.791a1.091,1.091,0,0,1,2.094,0l.405,1.42,1.42.405a1.091,1.091,0,0,1,0,2.094l-1.42.405-.405,1.423a1.091,1.091,0,0,1-2.094,0L20.012,5.12l-1.422-.407a1.091,1.091,0,0,1,0-2.094Z",
    transform: "translate(-0.077 0)",
    fill: "#ff643a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4499",
    "data-name": "Group 4499"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 411, 247)",
    filter: "url(#Ellipse_38)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38-2",
    "data-name": "Ellipse 38",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(49)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3984",
    "data-name": "Group 3984",
    transform: "translate(480.741 265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "form_2_",
    "data-name": "form (2)",
    d: "M10.2,10.288a3.086,3.086,0,1,0,0,6.173h4.115a3.086,3.086,0,0,0,0-6.173Zm5.144,3.086A1.029,1.029,0,0,1,14.317,14.4H10.2a1.029,1.029,0,1,1,0-2.058h4.115A1.029,1.029,0,0,1,15.345,13.374ZM17.4,19.547a1.029,1.029,0,0,1-1.029,1.029H8.144a1.029,1.029,0,1,1,0-2.058h8.23A1.029,1.029,0,0,1,17.4,19.547ZM20.012,3.211l-1.706-1.7A5.111,5.111,0,0,0,14.67,0H8.144A5.15,5.15,0,0,0,3,5.144v14.4a5.15,5.15,0,0,0,5.144,5.144h8.23a5.15,5.15,0,0,0,5.144-5.144V6.849a5.111,5.111,0,0,0-1.506-3.638ZM18.557,4.666a3.189,3.189,0,0,1,.389.478H16.374V2.572a3.017,3.017,0,0,1,.477.388Zm.9,14.881a3.086,3.086,0,0,1-3.086,3.086H8.144a3.086,3.086,0,0,1-3.086-3.086V5.144A3.086,3.086,0,0,1,8.144,2.058h6.173V5.144A2.058,2.058,0,0,0,16.374,7.2h3.086Z",
    transform: "translate(-3 0)",
    fill: "#ff643a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4498",
    "data-name": "Group 4498"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 411, 247)",
    filter: "url(#Ellipse_37)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37-2",
    "data-name": "Ellipse 37",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3992",
    "data-name": "Group 3992",
    transform: "translate(429 266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "folder",
    d: "M19.676,3.071h-6.76a1.055,1.055,0,0,1-.463-.1L9.184,1.327A3.121,3.121,0,0,0,7.8,1H5.178A5.184,5.184,0,0,0,0,6.178V18.6a5.184,5.184,0,0,0,5.178,5.178h14.5A5.184,5.184,0,0,0,24.853,18.6V8.249a5.184,5.184,0,0,0-5.178-5.178Zm-14.5,0H7.8a1.055,1.055,0,0,1,.463.1L11.527,4.81a3.121,3.121,0,0,0,1.389.332h6.76a3.107,3.107,0,0,1,2.878,1.949L2.071,7.207V6.178A3.107,3.107,0,0,1,5.178,3.071Zm14.5,18.64H5.178A3.107,3.107,0,0,1,2.071,18.6V9.278l20.711-.117V18.6A3.107,3.107,0,0,1,19.676,21.711Z",
    transform: "translate(0 -1)",
    fill: "#ff643a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.a9ae3f759676bb4fa23b9c53a0f2b933.svg";
export { ForwardRef as ReactComponent };